import { useEffect, useMemo, useRef, useState } from 'react';
import { FiMapPin } from 'react-icons/fi';
import { MOROCCAN_CITIES } from '../../utils/moroccanCities';
import './CityCombobox.css';

function CityCombobox({ value, onChange, placeholder = 'Toutes les villes', label, className = '' }) {
	const [inputVal, setInputVal] = useState(value || '');
	const [open, setOpen] = useState(false);
	const wrapRef = useRef(null);

	const suggestions = useMemo(() => {
		const q = inputVal.trim().toLowerCase();
		if (!q) return MOROCCAN_CITIES.slice(0, 12);
		const starts = MOROCCAN_CITIES.filter(c => c.toLowerCase().startsWith(q));
		const contains = MOROCCAN_CITIES.filter(c => c.toLowerCase().includes(q) && !c.toLowerCase().startsWith(q));
		return [...starts, ...contains].slice(0, 10);
	}, [inputVal]);

	useEffect(() => { setInputVal(value || ''); }, [value]);

	useEffect(() => {
		const handler = (e) => { if (!wrapRef.current?.contains(e.target)) setOpen(false); };
		document.addEventListener('mousedown', handler);
		return () => document.removeEventListener('mousedown', handler);
	}, []);

	const select = (city) => {
		setInputVal(city);
		onChange(city);
		setOpen(false);
	};

	const clear = () => {
		setInputVal('');
		onChange('');
		setOpen(false);
	};

	return (
		<div className={`ux-city-combobox ${className}`} ref={wrapRef}>
			{label && <span className="ux-city-combobox-label">{label}</span>}
			<div className="ux-city-combobox-input-wrap">
				<FiMapPin size={14} className="ux-city-combobox-icon" />
				<input
					type="text"
					className="ux-city-combobox-input"
					value={inputVal}
					placeholder={placeholder}
					onChange={e => { setInputVal(e.target.value); setOpen(true); }}
					onFocus={() => setOpen(true)}
					autoComplete="off"
				/>
				{inputVal && (
					<button type="button" className="ux-city-combobox-clear" onClick={clear} tabIndex={-1}>×</button>
				)}
			</div>
			{open && suggestions.length > 0 && (
				<ul className="ux-city-combobox-list" role="listbox">
					{suggestions.map(city => (
						<li
							key={city}
							className={`ux-city-combobox-item${city === value ? ' is-selected' : ''}`}
							role="option"
							aria-selected={city === value}
							onMouseDown={e => { e.preventDefault(); select(city); }}
						>
							<FiMapPin size={12} />
							{city}
						</li>
					))}
				</ul>
			)}
		</div>
	);
}

export default CityCombobox;
